import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { apiClient } from '@/api/http/client'
import type { ApiResponse } from '@/api/http/types'
import { queryKeys } from '@/api/query-keys'
import { IdentitySpAccountDeletionPath } from '../lib/constants'

export interface AccountDeletionStatusData {
  pending: boolean
  scheduledPurgeAt?: string | null
  graceDays?: number
  deletionRequestId?: string | null
  daysRemaining?: number | null
}

export interface AccountDeletionCancelData {
  cancelled: boolean
}

export function useAccountDeletionStatus(enabled = true) {
  return useQuery({
    queryKey: queryKeys.spAccountDeletion.status(),
    enabled,
    queryFn: async () => {
      const { data } = await apiClient.get<ApiResponse<AccountDeletionStatusData>>(
        IdentitySpAccountDeletionPath.STATUS
      )
      return data.data ?? { pending: false }
    },
    staleTime: 30_000,
  })
}

export function useCancelAccountDeletion() {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: async () => {
      const { data } = await apiClient.post<ApiResponse<AccountDeletionCancelData>>(
        IdentitySpAccountDeletionPath.CANCEL,
        {}
      )
      return data.data
    },
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: queryKeys.spAccountDeletion.status() })
    },
  })
}
